import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { ProjectAddPage } from './project-add';
import { SellionsFormsModule } from '../../../../submodules/sellions_forms/projects/forms/src/public-api';

@NgModule({
  declarations: [ProjectAddPage],
  imports: [SellionsFormsModule, IonicPageModule.forChild(ProjectAddPage)],
})
export class ProjectAddModule {}



// WEBPACK FOOTER //
// ./src/modules/projects/pages/project-add/project-add.module.ts